module.exports = __webpack_public_path__ + "static/cat-and-laptop-1-4aa16d06bf31a4c4f7849e33a2d6e80b.png";